import React, { useEffect, useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import {
  getProgramBudgetApplications,
  fetchInProgressApplications,
} from "../../features/application";

const ProgramSummaryBar = ({
  title,
  total,
  completed,
  in_progress,
  program,
  type,
}) => {
  const dispatch = useDispatch();

  const [completeCost, setCompleteCost] = useState(null);
  const [inProgressCost, setInProgressCost] = useState(null);

  useEffect(() => {
    if (!program?.id) return;

    const fetchSummaryCounts = async () => {
      try {
        const [completedRes, inProgressRes] = await Promise.all([
          dispatch(getProgramBudgetApplications({ programId: program.id })),
          dispatch(fetchInProgressApplications({ programId: program.id })),
        ]);

        const completedCost =
          type === "programBudget"
            ? parseFloat(completedRes.payload?.cost || "0")
            : parseFloat(completedRes.payload?.grantFundedAmount || "0");

        console.log("completedRes.payload?.cost", completedRes.payload?.cost);
        const inProgressCost =
          type === "programBudget"
            ? parseFloat(inProgressRes.payload?.cost || "0")
            : parseFloat(inProgressRes.payload?.grantFundedAmount || "0");

        const total = completedCost + inProgressCost;
        setCompleteCost(completedCost);
        setInProgressCost(
          total % 1 === 0 ? total : parseFloat(total.toFixed(2))
        );
      } catch (err) {
        console.error("Error fetching summary counts:", err);
      }
    };

    fetchSummaryCounts();
  }, [program?.id, dispatch]); // Runs only when `program.id` or `dispatch` changes

  return (
    <div className="flex flex-col w-full p-[2rem] ">
      <div className="flex flex-row">
        <span className="text-lg font-bold">{title}</span>
      </div>
      <div className="flex flex-row">
        <span className="text-md">
          $
          {completeCost?.toLocaleString(undefined, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          })}
          /$
          {total?.toLocaleString(undefined, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          }) || "0"}{" "}
          budget spent (<span className="text-green-700">completed</span>{" "}
          applications)
        </span>
      </div>

      <div className="flex flex-row">
        <span className="text-md">
          $
          {inProgressCost?.toLocaleString(undefined, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          })}
          /$
          {total?.toLocaleString(undefined, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          }) || "0"}{" "}
          budget spent (<span className="text-green-700">completed</span> +
          <span className="text-orange-300"> in progress</span> applications)
        </span>
      </div>
      <div className="flex flex-row w-full h-[4rem]">
        <div
          className="flex flex-col h-full bg-lime-700"
          style={{
            width: (completeCost / total) * 100 + "%",
          }}
        >
          {completeCost && (
            <span className="text-lg text-center mt-auto mb-auto text-gray-50 font-bold">
              {`${Math.floor((completeCost / total) * 100)} %`}
            </span>
          )}
        </div>
        <div
          className="flex flex-col h-full bg-amber-400"
          style={{
            width: ((inProgressCost - completeCost) / total) * 100 + "%",
          }}
        >
          {in_progress && (
            <span className="text-lg text-center mt-auto mb-auto text-gray-50 font-bold">
              {Math.floor((inProgressCost / total) * 100)}%
            </span>
          )}
        </div>
        <div
          className="flex flex-col h-full bg-gray-300"
          style={{
            width: Math.floor(((total - in_progress) / total) * 100) + "%",
          }}
        />
      </div>

      {program.defaultUnitCost ? (
        <div className="flex flex-row w-full">
          <span className="text-lg">
            <span className="font-bold text-lg">
              {Math.floor((total - inProgressCost) / program.defaultUnitCost)}
            </span>{" "}
            estimated additional applications can be{" "}
            {title.includes("Fund") ? "funded" : "accepted"}
          </span>
        </div>
      ) : null}
    </div>
  );
};

export default ProgramSummaryBar;
